import api from './api';
import types from './mutation-types';
import WidgetUserMap from './WidgetUserMap';
import WidgetComponent from './WidgetComponent';

export default {
	selectUserWidgetList_({ commit }) {
		return api.selectUserWidgetList().then(res => {
			const { body } = res;
			const widgetComponents = body.map(r => new WidgetComponent(r));
			commit(types.SET_WIDGET_ITEMS, widgetComponents);
			return body;
		});
	},
	selectWidgetMaster_({ commit }) {
		return api.selectWidgetMaster().then(res => {
			const { body } = res;
			const value = body.map(r => ({ ...r, parameter: JSON.parse(r.parameter || null), isResizable: r.resizeYn === 'Y' }));
			commit(types.SET, { key: 'widgetMaster', value });
			return value;
		});
	},
	loadComponents_({ commit }, widgetMaster) {
		const widgetList = widgetMaster.reduce(
			(obj, { widgetTitle, widgetMstFileId, ...res }) =>
				Object.assign(obj, {
					[widgetTitle]: {
						...res,
						widgetTitle,
						widgetMstFileId,
						component: () => {
							try {
								return widgetTitle && import(`@common/WidgetComponent/${widgetMstFileId}/${widgetMstFileId}.vue`);
							} catch (e) {
								// console.log('failed to import widget component :', widgetTitle);
								return null;
							}
						}
					}
				}),
			{}
		);
		commit(types.SET, { key: 'dynamicComp', value: widgetList });
	},
	insertWidgetItem_({ state: { widgetItems, dynamicComp }, commit }, item) {
		commit('clearDisplayCoachMarkFlag');

		const targetIdx = widgetItems.findIndex(r => r.i === item.i);
		if (!widgetItems[targetIdx].dragging) {
			return;
		}
		Object.assign(item, dynamicComp[item.widgetTitle]);
		item = new WidgetUserMap(item);
		return api
			.insertUserWidgets([item])
			.then(res => {
				const {
					header: { message, code },
					body: [newItem]
				} = res;
				newItem.resizeYn = dynamicComp[newItem.widgetTitle].resizeYn;
				widgetItems[targetIdx] = new WidgetComponent(newItem);
				commit(types.SET_WIDGET_ITEMS, [...widgetItems]);
				return { message, type: code === '0' ? 'ok' : 'error' };
			})
			.catch(r => {
				return { message: 'error', type: 'error' };
			});
	},
	deleteWidgetItem_({ state: { widgetItems }, commit, dispatch }, item) {
		widgetItems = widgetItems.filter(r => r.i !== item.i);
		commit(types.SET_WIDGET_ITEMS, widgetItems);
		dispatch('updateWidgetItems_', [{ ...item, useYn: 'N' }]);
	},
	updateWidgetItem_({ commit, state }, newWidgetItem) {
		const { widgetItems } = state;
		widgetItems = widgetItems.map(item => (item.i === newWidgetItem.i ? newWidgetItem : item));
		commit(types.SET_WIDGET_ITEMS, [...widgetItems]);
		api.updateUserWidgets([new WidgetUserMap(newWidgetItem)]);
	},
	updateWidgetItems_({ state }, newWidgetItems) {
		const items = newWidgetItems.map(r => new WidgetUserMap(r));
		api.updateUserWidgets(items);
	},
	onChangeWidgetItem_({ commit, state }, { i, settings }) {
		const { widgetItems } = state;
		const index = widgetItems.findIndex(r => r.i === i);
		const para = Object.assign(widgetItems[index].para, { settings });
		const target = { ...widgetItems[index], para };
		widgetItems[index] = target;
		commit(types.SET_WIDGET_ITEMS, [...widgetItems]);
	},
	clearDisplayCoachMarkFlag_({ commit }) {
		commit('clearDisplayCoachMarkFlag');
	}
};
